import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

import CustomLink from '@shared/components/customLink'

function HeaderCardsHeader({ data = [], i18nKeyText = false }) {
  return (
    <div>
      <div className={`${styles.headerWrapper}`}>
        <div className={`${styles.headerContainer}`}>
          <h4 className={`${styles.h4MarginBtm}`}>{data.title}</h4>
          {Object.entries(data?.routeLinks || {}).length > 0 && (
            <div className={`${styles.scorecardNav}`}>
              {Object.entries(data?.routeLinks || {}).map(([key, href], idx) => {
                const label = key.charAt(0).toUpperCase() + key.slice(1)
                return (
                  <CustomLink key={`header-button-${idx}`} href={href} prefetch={false}>
                    <a className={styles.headerButton}>{label}</a>
                  </CustomLink>
                )
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

HeaderCardsHeader.propTypes = {
  data: PropTypes.object,
  i18nKeyText: PropTypes.bool
}

export default HeaderCardsHeader
